import { render } from "./ButtonSide.vue?vue&type=template&id=60688072&scoped=true&ts=true"
import script from "./ButtonSide.vue?vue&type=script&lang=ts"
export * from "./ButtonSide.vue?vue&type=script&lang=ts"

import "./ButtonSide.vue?vue&type=style&index=0&id=60688072&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60688072"]])

export default __exports__